var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-full"},[_c('BasicTemplate',[(_vm.data)?_c('EventContainer',{attrs:{"title":_vm.data.title,"desc":_vm.data.desc,"date":_vm.data.date,"contacts":_vm.data.contacts}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }